let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2MWz6")).then(() => parcelRequire('ecpW1'));